import React,{ useEffect, useState } from 'react'
import { Divider, Input, Select, Spin, Tabs } from 'antd';
import { DetailContainer, FormItem, FormikForm } from '../../../StyledComponents/CreateKeyAccountManager'
import { HeadContainer } from '../../../StyledComponents/Dashboard';
import { DetailContent, DetailRow, LeftContent, MidContent,BottomContent, RightContent, RowValue, TableInput, TableItem, TDItem, THeadItem, THItem, Title, TitleDiv, TitleRow, TopButtonDiv, TopContent, TRItem, TableFilter } from '../../../StyledComponents/RateManagement';
import SubmitButton from '../Common/SubmitButton';
import { ErrorMessage } from 'formik';
import { move_rate_archive } from '../../../store/Admin/RateManagement/RateManagementSlice';
import { useDispatch } from 'react-redux';
import { airlines_list, airport_list, updatenotificationdata } from '../../../store/Admin/Common/CommonSlice';
import { httpinstance } from '../../../axios/api';
// import SelectSearchAirline from '../Common/SelectSearchAirline';
import SelectSearchPort from '../Common/SelectSearchPort';
import styled from 'styled-components';
import * as Yup from 'yup'
// import { handleKeyPress } from '../../functions/Utils';
import { SpinContainer } from '../../../StyledComponents/Queries';
// import AddButton from '../Common/AddButton';
import { TableTab } from '../../../StyledComponents/Common';
import { useLocation } from 'react-router-dom';

import RadioGroups from '../Common/RadioGroups';
import SelectSearchAirlineNumcode from '../Common/SelectSearchAirlineNumcode';
//import { REACT_APP_API_BASE_URL_NODE } from '../../utils/secondsToTime';



const validationSchema = Yup.object().shape({
    num_code: Yup.string().nullable().required('Num Code is required'),
    destination_port: Yup.string().nullable().required('Destination Port is required'),
    origin_port: Yup.string().nullable().required('Origin Port is required'),
    ship_type: Yup.string().nullable().required('Ship Type is required'),
    charge_name: Yup.string().nullable().required('Charge Name is required'),
    charge_amount: Yup.string().required('Charge Amount is required'),
    charge_basis: Yup.string().nullable().required('Charge Basis is required'),
    min_charge_amount: Yup.string().required('Min Charge Amount is required'),
    min_charge_basis: Yup.string().nullable().required('Min Charge Basis is required'),
})

function SurchargeDetailPage(props) {
    const dispatch = useDispatch()
    const [spinner, setSpinner] = useState(false);
    const [loading, setLoading] = useState(true);
    const [archieve_loading, setArchiveLoading] = useState(false);
    const [type, setType] = useState(props.type);
    // const [tabType, setTabType] = useState("air");
    const [state, setState] = useState({
        airline_list: [],
        airport_list: [],
    });

    const location = useLocation();
    const [isLoad, setIsLoad] = useState(true);
    useEffect(()=> {
        if(location.pathname === '/rate-management'){
        if(isLoad === false){
            props.setPageType("table")
        }else {
            setIsLoad(false)
        }
        }
    },[location])

    useEffect(()=>{
        dispatch(airlines_list())
        .then(res=>{
            // console.log('login res => ',res);
            if(res?.payload?.status === 200 ){
                let data = res?.payload?.data?.data
                let numCodeArr = data.filter((obj, index, self) =>
                    index === self.findIndex((o) => o.num_carr_code === obj.num_carr_code)
                );
                setState((prevState) => {
                    return {
                        ...prevState,
                        airline_list: numCodeArr
                    }
                })
            }
        })
        .catch(err=>{
            console.error(err);
        })

        setState((prevState) => {
            return {
                ...prevState,
                airport_list: props?.airport_list
            }
        })
        setLoading(false)
        // dispatch(airport_list())
        // .then(res=>{
        //     // console.log('login res => ',res);
        //     if(res?.payload?.status === 200 ){
        //         const airports = res?.payload?.data?.data
        //         const indianAirports = airports.filter(airport => airport.countryName === 'INDIA' || airport.countryName === 'India');
        //         indianAirports.sort((a, b) => a.name.localeCompare(b.name));
                
        //         const foreignAirports = airports.filter(airport => airport.countryName !== 'India' || airport.countryName !== 'INDIA');
        //         foreignAirports.sort((a, b) => {
        //         if (a.country === b.country) {
        //             return a.name.localeCompare(b.name);
        //         }
        //         return a.country.localeCompare(b.country);
        //         });
        //         const sortedAirports = indianAirports.concat(foreignAirports);
        //         let resultPorts = sortedAirports.filter((obj, index, self) =>
        //             index === self.findIndex((o) => o.code === obj.code)
        //         );
        //         setState((prevState) => {
        //             return {
        //                 ...prevState,
        //                 airport_list: resultPorts
        //             }
        //         })
        //         setLoading(false)
        //     }
        // })
        // .catch(err=>{
        //     console.error(err);
        // })
    },[])

    const handleCancel = (resetForm) => {
        setType("view")
        props.setType("view")
        resetForm()
    }

    const handleEdit = () => {
        setType("edit")
        props.setType("edit")
    }
    const handleSelectChange = (e,name,setFieldValue)=> {
        setFieldValue([name],e)
    }

    const handleArchive = () => {
        setArchiveLoading(true)
        let rate_id = props.instance._id
          const values = {
            rate_id : rate_id,
            customType: "Air"
          }
          dispatch(move_rate_archive(values))
          .then(res=>{
              if(res?.payload?.data?.statusCode === 200 ){
                //   console.log(res?.payload?.data?.data);
                  dispatch(updatenotificationdata(res?.payload?.data))
                  setArchiveLoading(false)
                  props.setPageType("table")
                  props.setCallList(true)
              }
          })
          .catch(err=>{
              console.error(err);
          })
      }

    const initialValues = {
        airline: props.instance?.airline ? props.instance?.airline : '',
        destination_port: props.instance?.destination ? props.instance?.destination : null,
        origin_port: props.instance?.origin ? props.instance?.origin : null,
        carr_code: props.instance?.carr_code ? props.instance?.carr_code : null,
        num_code: props.instance?.num_code ? props.instance?.num_code : null,
        ship_type: props.instance?.ship_type ? props.instance?.ship_type : null,
        charge_name: props.instance?.chargeName ? props.instance?.chargeName : null,
        charge_basis: props.instance?.chargeBasis ? props.instance?.chargeBasis : null,
        charge_amount: props.instance?.chargeAmount ? props.instance?.chargeAmount : '',
        min_charge_amount: props.instance?.minChargeAmount ? props.instance?.minChargeAmount : '',
        min_charge_basis: props.instance?.minChargeBasis ? props.instance?.minChargeBasis : null,
        customType: "Air",
        id: props.instance?._id ? props.instance?._id : '',
      }

   
    // const carr_code_list = state.airline_list.filter((obj,index,self) => {
    //     return index === self.findIndex((t) => (
    //         t.carr_code === obj.carr_code 
    //     ));
    // })

    const ship_types = [{
            value: "General",
            name: "General"
        },
        {
            value: "Special",
            name: "Special"
        },
        {
            value: "Dangerous Goods",
            name: "Dangerous Goods"
        },
        {
            value: "Temperature Controlled/Pharma",
            name: "Temperature Controlled/Pharma"
        },
        {
            value: "Other Special Commodity",
            name: "Other Special Commodity"
        }
    ]

    const charge_names = [{
            value: "SSC",
            name: "SSC"
        },
        {
            value: "FSC",
            name: "FSC"
        },
        {
            value: "MISC",
            name: "MISC"
        },
        {
            value: "XRAY",
            name: "XRAY"
        },
        {
            value: "AMS",
            name: "AMS"
        },
        {
            value: "CTG",
            name: "CTG"
        },
        {
            value: "Others",
            name: "Others"
        }
    ]

    const charge_basises = [{
            value: "Flat",
            name: "Flat"
        },
        {
            value: "KG",
            name: "KG"
        }
        ,{
            value: "percentage",
            name: "Percentage"
        }
    ]
    const charge_basises2 = [{
        value: "Flat",
        name: "Flat"
    },
 
]


    if(loading){
        return (
                <SpinContainer className='user-quote'>
                    <Spin />
                </SpinContainer>
            )
    }else {
        return (
            <FormikForm
                initialValues={initialValues}
                validationSchema={validationSchema}

                onSubmit={async(values,{resetForm}) => {
                    setSpinner(true)
                    let data = {
                        "customType": "Air",
                        "Origin": values.origin_port,
                        "Destination": values.destination_port,
                        "Charge Name": values.charge_name,
                        "Num Code": values.num_code,
                        "Ship Type": values.ship_type,
                        "Charge Amount": values.charge_amount,
                        "Charge Basis": values.charge_basis,
                        "Min Charge Amount": values.min_charge_amount,
                        "Min Charge Basis": values.min_charge_basis,
                        "Airline": values.airline,
                    }
                    try {
                        const result = await httpinstance.post(
                            `addsurcharge`,
                            data
                            );
                            if(result.status === 200){
                                let data = {
                                    message : result.data.message,
                                    statusCode: 200,
                                    success: result.data.status
                                }
                                dispatch(updatenotificationdata(data))
                                setSpinner(false);
                                resetForm()
                                props.setCallList(true)
                                props.setPageType("table")
                            }
                    } catch (error) {
                        console.log(error);
                        setSpinner(false);
                    }
                    
            }}
            >
            {({ values,setFieldValue, handleChange, handleBlur, resetForm }) => (
                <FormItem>
            <DetailContainer>
            <HeadContainer>
                    <TableFilter>
                        <>
                        <TableTab className='first' active={props.tabType === 'air'} onClick={()=> props.setTabType('air')}>Air</TableTab>
                        {/* {type === 'create'? 
                            <>
                                <Divider type="vertical" />
                                <TableTab active={props.tabType === 'ocean'} onClick={()=> props.setTabType('ocean')}>Ocean</TableTab>
                            </>
                        : null} */}
                        </>
                         <TableFilter className='mb-2'>
                            <RadioGroups datas={props.sub_filter} value={props.subTabType} handleClick={Object.keys(props.instance).length === 0 ? props.handleRadioClick : null} name="air" />
                        </TableFilter>
                    </TableFilter>  
                    <TopButtonDiv className='mb-3'>
                            {/* {type === 'view'?
                                <AddButton title="Move To Archive" icon_type="archive" handleClick={()=> handleArchive()} loading={archieve_loading} />
                            : null} */}
                        {type === 'edit' || type === 'create' ? 
                        <>  {type === 'edit' ? <SubmitButton type='button' title="Cancel" is_icon={false} handleClick={()=> handleCancel(resetForm)} /> : null}
                            <SubmitButton type='submit' title="save" is_save={true} loading={spinner} />
                        </>
                        : <SubmitButton type="button" title="Edit" icon_type="edit" handleClick={()=> handleEdit()} /> }
                    </TopButtonDiv>
                    
            </HeadContainer>
                <BottomContent>
                    <LeftContent>
                    <DetailRow>
                            <TitleDiv>
                            <TitleRow>Num Code*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <SelectSearchAirlineNumcode name="num_code" value={values.num_code} setFieldValue={setFieldValue} options={state.airline_list} 
                                width="100%" bradius="8px" placeholder="Num Code" />
                                <ErrorMessage name="num_code" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.num_code}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>Destination Airport*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <SelectSearchPort name="destination_port" setFieldValue={setFieldValue} value={values.destination_port} options={state.airport_list} width="100%" bradius="8px" placeholder="Destination Airort" />
                                <ErrorMessage name="destination_port" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.destination_port}</RowValue> }
                            
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>Charge Name*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <ItemSelect
                                    size="large"
                                    id="charge_name"
                                    name="charge_name"
                                    placeholder="Charge Name"
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={(e) => handleSelectChange(e,"charge_name",setFieldValue)}
                                    options={charge_names}
                                    value={values.charge_name}
                                />
                                <ErrorMessage name="charge_name" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.charge_name}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>Min Charge Amount*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="min_charge_amount"
                                    name="min_charge_amount"
                                    value={values.min_charge_amount}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='Min Charge Amount'
                                />
                                <ErrorMessage name="min_charge_amount" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue className='raw-width'>{values.min_charge_amount}</RowValue> }
                        </DetailRow>
                        
                    </LeftContent>
                    <LeftContent>
                    <DetailRow>
                            <TitleDiv>
                                <TitleRow>Airline</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="airline"
                                    name="airline"
                                    // value={state.airline_list?.filter((i)=> i.carr_code === values.carr_code && i.num_carr_code === values.num_code)[0]?.carr_name}
                                    value={values.airline}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='Airline'
                                    disabled
                                />
                                <ErrorMessage name="airline" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            // <RowValue>{state.airline_list?.filter((i)=> i.carr_code === values.carr_code && i.num_carr_code === values.num_code)[0]?.carr_name}</RowValue> }
                            <RowValue>{values.airline}</RowValue> }
                            
                        </DetailRow>
                        
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>Charge Amount*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="charge_amount"
                                    name="charge_amount"
                                    value={values.charge_amount}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='Charge Amount'
                                />
                                <ErrorMessage name="charge_amount" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue className='raw-width'>{values.charge_amount}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>Min Charge Basis*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <ItemSelect
                                    size="large"
                                    id="min_charge_basis"
                                    name="min_charge_basis"
                                    placeholder="Min Charge Basis"
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={(e) => handleSelectChange(e,"min_charge_basis",setFieldValue)}
                                    options={charge_basises2}
                                    value={values.min_charge_basis}
                                />
                                <ErrorMessage name="min_charge_basis" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.min_charge_basis}</RowValue> }
                        </DetailRow>
                        <DetailRow></DetailRow>
                        <DetailRow></DetailRow>
                    </LeftContent>
                    <LeftContent>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>Origin Airport*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <SelectSearchPort name="origin_port" setFieldValue={setFieldValue} value={values.origin_port} options={state.airport_list} width="100%" bradius="8px" placeholder="Origin Airort" />
                                <ErrorMessage name="origin_port" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.origin_port}</RowValue> }
                            
                        </DetailRow>
                        
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>Ship Type*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <ItemSelect
                                    size="large"
                                    id="ship_type"
                                    name="ship_type"
                                    placeholder="Ship Type"
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={(e) => handleSelectChange(e,"ship_type",setFieldValue)}
                                    options={ship_types}
                                    value={values.ship_type}
                                />
                                <ErrorMessage name="ship_type" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.ship_type}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>Charge Basis*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <ItemSelect
                                    size="large"
                                    id="charge_basis"
                                    name="charge_basis"
                                    placeholder="Charge Basis"
                                    style={{
                                        width: '100%',
                                    }}
                                    onChange={(e) => handleSelectChange(e,"charge_basis",setFieldValue)}
                                    options={charge_basises}
                                    value={values.charge_basis}
                                />
                                <ErrorMessage name="charge_basis" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.charge_basis}</RowValue> }
                        </DetailRow>
                        <DetailRow></DetailRow>
                        <DetailRow></DetailRow>
                    </LeftContent>
                </BottomContent>
            </DetailContainer>
                </FormItem>
            )}
            </FormikForm>
            
        )
    }
}

export default SurchargeDetailPage


const ItemSelect = styled(Select)`
    & .ant-select-selector {
        border-radius: 8px !important;
        padding: ${({ pdg }) => pdg? pdg : "unset"};
    }
    & .ant-select-selection-placeholder {
        color: #d9d9d9 !important;
        font-size: 16px;
        font-weight: 400;
    }
    & .ant-select-arrow {
        color: #d9d9d9 !important
    }
    /* & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    } */
`